<template>
  <div class="components-container">
    <header>
      <span class="title">续费订单</span>
      <div class="right">
        <el-input class="seach" size="small" v-model="searchInput" placeholder="客户名称" suffix-icon="el-icon-search" @keyup.enter.native="search"></el-input>
        <el-select v-model="business_type" placeholder="业务类型" size="small" clearable  @change="businessChange" style="margin-left: 8px;">
          <el-option v-for="item in businessData" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
    </header>
    <el-table class="el-table-01" :data='tableList' style='width: 100%' @row-click="rowClick" @selection-change='handleSelectionChange'>
      <el-table-column prop='third_party_no' label='订单号' min-width='240'></el-table-column>
      <el-table-column prop='company_name' label='客户名称' min-width='240'></el-table-column>
      <el-table-column prop='order_status' label='订单状态' min-width='100'>
        <template slot-scope='scope'>
          <span v-if="scope.row.order_status == 0">待支付</span>
          <span v-else-if="scope.row.order_status == 1" style="color: #FF0300;">支付成功</span>
          <span v-else-if="scope.row.order_status == 2">取消订单</span>
        </template>
      </el-table-column>
      <el-table-column prop='pay_type' label='付款方式' min-width='100'>
        <template slot-scope='scope'>{{ scope.row.pay_type == 1 ? '微信' : '支付宝' }}</template>
      </el-table-column>

      <el-table-column label='付款时间' min-width='160'>
        <template slot-scope='scope'>{{ scope.row.pay_time | formatDate('yyyy-MM-dd HH:mm') }}</template>
      </el-table-column>
      <el-table-column prop='use_number' label='业务类型' min-width='120'>
        <template slot-scope='scope'>
          {{businessRemark[scope.row.business_type]}}
        </template>
      </el-table-column>
      <el-table-column prop='order_content' label='数量' min-width='100'>
        <template slot-scope='scope'>
          <span v-text="contentInit(scope.row)"></span>
        </template>
      </el-table-column>
      <el-table-column prop='order_amount' label='金额' min-width='120'></el-table-column>
    </el-table>
    <el-pagination @size-change='handleSizeChange' @current-change='handleCurrentChange' :current-page='pageNum' :page-sizes='[10, 20, 50, 100]' :page-size='pageSize' layout='total, sizes, prev, pager, next, jumper' :total='tableTotal'></el-pagination>
  </div>
</template>

<script>
import mixin from '@/common/js/mixins.js'
import renewOrder from '@/controller/renewOrder.js'
export default {
  data () {
    return {
      defaultMsg: '<b>续费订单</b>'
    }
  },
  mixins: [renewOrder, mixin],
  components: {
  }
}
</script>



// WEBPACK FOOTER //
// src/page/business/renewOrder.vue